import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=4c2a8d56&"
import script from "./Callout.vue?vue&type=script&setup=true&lang=js&"
export * from "./Callout.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Callout.vue?vue&type=style&index=0&id=4c2a8d56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports